import axios from 'axios'

const endPoint = '/coach-dashboard/ct-dashboard'

export function getItems({ commit, state }, props) {

    var params = {
        sortBy: props.pagination.sortBy,
        descending: props.pagination.descending,
        page: props.pagination.page,
        rowsPerPage: props.pagination.rowsPerPage,
        search: props.filter?.search,
        customers: props.filter?.customers,
        start_date: (props.filter && props.filter.dateRange && props.filter.dateRange.startDate) ? props.filter?.dateRange.startDate : '',
        end_date: (props.filter && props.filter.dateRange && props.filter.dateRange.endDate) ? props.filter?.dateRange.endDate : '',
        status: props.filter?.status,

    }

    return new Promise((resolve, reject) => {
        axios
            .get(endPoint, {
                params: params
            })
            .then(response => {
                commit('setAvgCalc', response.data)
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
}
